module.exports = __webpack_public_path__ + "static/media/tti_manager_intro.9810af70.png";